import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const META_PIXEL_ID = '1651357612587495';
type MetaPixel = {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: (...args: unknown[]) => void;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & MetaPixel;
    _fbq?: MetaPixel;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel = function (...args: unknown[]) {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
        } as ((...args: unknown[]) => void) & MetaPixel;
        pixel.queue = [];
        pixel.push = (...args: unknown[]) => pixel.queue.push(args);
        pixel.loaded = true;
        pixel.version = '2.0';
        window.fbq = pixel;
        if (!window._fbq) window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init failed:', error);
    }
  }, []);
  return <div className="min-h-screen bg-black text-white selection:bg-gold/30 selection:text-gold-light" data-id="element-0" data-mp="3udaw269tuj3n">
      <main data-id="element-1" data-mp="d57fh2ybeij2">
        <Hero data-id="element-2" data-mp="d3mkxdc02zl7" />
        <TestimonialsStrip data-id="element-3" data-mp="d3crffrqyaar" />
        <PainPoints data-id="element-4" data-mp="d2l6cyvrzuyq" />
        <SolutionReveal data-id="element-5" data-mp="85uj9rljzz3t" />
        <TomosSection data-id="element-6" data-mp="85b8cuubmaza" />
        <BonusSection data-id="element-7" data-mp="8648hcyry28g" />
        <PricingSection data-id="element-8" data-mp="83i6rtykegy5" />
        <ExtendedTestimonials data-id="element-9" data-mp="3gl4qfe4avuig" />
        <Guarantee data-id="element-10" data-mp="3gmfsn9i3ku7g" />
        <FAQ data-id="element-11" data-mp="3glnzs6fvxakv" />
        <FinalCTA data-id="element-12" data-mp="3gja887keygi2" />
      </main>
      <Footer data-id="element-13" data-mp="3bmtixa1h9w3e" />
      <PurchaseNotifications data-id="element-14" data-mp="3bn2zy84joswy" />
    </div>;
}